import { SET_COLLAPSED, StegVisning, StegVisningActionTypes } from './Types';

const initialState: { [id: string]: StegVisning } = {};

export function stegVisningReducer(
    state: {
        [id: string]: StegVisning;
    } = initialState,
    action: StegVisningActionTypes,
): {
    [id: string]: StegVisning;
} {
    switch (action.type) {
        case SET_COLLAPSED: {
            const newState = { ...state };
            newState[action.payload.id] = {
                id: action.payload.id,
                isCollapsed: action.payload.isCollapsed,
            };
            return newState;
        }
        default:
            return state;
    }
}
